/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

type CartState = {
  isOpen: boolean;
  badgeCount: number;
};

const initialState: CartState = {
  isOpen: false,
  badgeCount: 0,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    openCart: (state) => {
      state.isOpen = true;
    },
    closeCart: (state) => {
      state.isOpen = false;
    },
    updateBadgeCount: (state, { payload }) => {
      state.badgeCount = payload;
    },
  },
});

export const { openCart, closeCart, updateBadgeCount } = cartSlice.actions;

export const cartSelector = (state: RootState) => state.cart;

export default cartSlice.reducer;
